site.logomenu = site.logomenu || {};
site.logomenu = $.extend(true, {
	options: {
		logoElement: 'header .logo a',
		contextMenuId: 'logoContextMenu',
		lang: {
			is: {
				gotoFrontpage: 'Fara á forsíðu',
				moyaLogin: 'Innskráning í Moya',
				moyaHelp: 'Leiðbeiningar fyrir Moya',
				moyaHelpUrl: 'https://www.stefna.is/is/adstod',
			},
			en: {
				gotoFrontpage: 'Goto frontpage',
				moyaLogin: 'Moya login',
				moyaHelp: 'Moya help',
				moyaHelpUrl: 'https://www.stefna.is/is/adstod',
			}
		}
	},

	init: function () {
		site.logomenu.createMenu();
		site.logomenu.addContextMenu();
	},

	createMenu: function () {
		const menuItems = site.logomenu.getMenuItems();
		if (menuItems) {
			const nav = document.createElement('nav');
			nav.id = site.logomenu.options.contextMenuId;
			nav.appendChild(menuItems);
			document.body.appendChild(nav);
		}
	},

	getMenuItems: function () {
		const nav = document.createElement('ul'),
			isFrontpage = hasClass('frontpage'),
			isLoggedIn = hasClass('loggedIn')
		;

		if (!isFrontpage) {
			nav.appendChild(createMenuItem(__('gotoFrontpage'), {
				href: '/' + moya.division,
				class: 'home',
			}));
		}

		site.logomenu.getExtraMenuItems(nav);

		if (!isLoggedIn && getCookie('auth_hasLoggedIn')) {
			nav.appendChild(createMenuItem(__('moyaLogin'), {
				href: '/' + moya.division + '/moya/auth?return_url=' + window.location.pathname,
				class: 'login',
			}));
		}

		if (isLoggedIn) {
			nav.appendChild(createMenuItem(__('moyaHelp'), {
				href: __('moyaHelpUrl'),
				target: '_black',
				class: 'help',
			}));
		}

		function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}

		function hasClass(className) {
			return document.body.classList.contains(className);
		}

		return nav;

		function createMenuItem(label, attributes) {
			return site.logomenu.createMenuItem(label, attributes);
		}

		function __(label) {
			return site.logomenu.__(label);
		}
	},

	createMenuItem: function (label, attributes) {
		const a = document.createElement('a');
		a.innerHTML = label;
		for (var key in attributes) {
			if (attributes.hasOwnProperty(key)) {
				a.setAttribute(key, attributes[key]);
			}
		}
		const li = document.createElement('li');
		li.appendChild(a);
		return li;
	},

	__: function (label) {
		return site.logomenu.options.lang[moya.lang][label] || '';
	},

	getExtraMenuItems: function (nav) {

	},

	addContextMenu: function () {
		const options = site.logomenu.options,
			contextMenu = document.getElementById(options.contextMenuId),
			logo = document.querySelector(options.logoElement)
		;

		if (contextMenu && logo) {
			logo.addEventListener('contextmenu', function (e) {
				e.preventDefault();
				contextMenu.style.display = 'block';
				contextMenu.style.left = (e.clientX - 10) + 'px';
				contextMenu.style.top = (e.clientY - 10) + 'px';
			}, false);
			window.addEventListener('click', function (e) {
				contextMenu.removeAttribute('style');
			}, false);
		}
	}

}, site.logomenu);

site.inits.push('site.logomenu.init()');
